import { render, staticRenderFns } from "./MiniLoader.vue?vue&type=template&id=41f57b54"
var script = {}
import style0 from "./MiniLoader.vue?vue&type=style&index=0&id=41f57b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports